<template>
    <div id="navigation">
        <a href="//www.forfunds.cn/platform/pcweb.html" target="_self" class="logo">
            <i></i>
            <img src="~@/assets/img/logo.png" alt="">
        </a>
        <router-link to="/simu-account-application">模拟账户申请</router-link>
    </div>
</template>

<script>
// import ThsLogin from '@/lib/'
export default {
    data () {
        return {
            newstockReverseVisible: false,
            questionVisible: false,
            phoneVisible: false,
            feedbackVisible: false,
            isIntranet: false
        }
    },
    computed: {
        userId () {
            return this.$store.getters['userInfo/userId']
        },
        userName () {
            return this.$store.getters['userInfo/userName']
        }
    },
    methods: {
    }
}
</script>

<style lang="scss">
    #navigation {
        background: #001529;
        width: 256px;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        z-index: 10;
        .logo {
            width: 100%;
            height: 64px;
            padding-left: 0;
            padding-right: 27px;
            box-sizing: border-box;
            i {
                display: inline-block;
                width: 57px;
                height: 100%;
                background: url('~@/assets/img/arrow_left.png');
                cursor: pointer;
                &:hover {
                    background: url('~@/assets/img/arrow_left_hover.png');
                }
                &:active {
                    background: url('~@/assets/img/arrow_left_active.png');
                }
            }
            img {
                float: right;
                margin-top: 20px;
            }
        }
        a {
            display: block;
            width: 100%;
            height: 60px;
            line-height: 60px;
            text-decoration: none;
            color: #b3b3b3;
            font-weight: 120;
            padding: 0 50px;
            box-sizing: border-box;
            &:nth-child(2) {
                background: no-repeat url('~@/assets/img/account-icon.png') 20px center;
                &.router-link-active {
                    color: white;
                    background: no-repeat url('~@/assets/img/account_active_icon.png') 20px center #108ee9;
                }
            }
            &:nth-child(3) {
                background: no-repeat url('~@/assets/img/interface_icon.png') 20px center;
                &.router-link-active {
                    color: white;
                    background: no-repeat url('~@/assets/img/interface_active_icon.png') 20px center #108ee9;
                }
            }
            &:nth-child(4) {
                background: no-repeat url('~@/assets/img/account_manage.png') 20px center;
                &.router-link-active {
                    color: white;
                    background: no-repeat url('~@/assets/img/account_manage_active.png') 20px center #108ee9;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/common/navigation.vue